import * as React from 'react'

import { MessageSquareTextIcon } from 'lucide-react'

import './ChatIconWithBadge.scss'

interface IProps {
  count: number
}

export default function ChatIconWithBadge({ count }: IProps) {
  return (
    <div className="relative chat-badge-container">
      <MessageSquareTextIcon size={24} className="tw:block tw:fill-none!" />
      {!!count && (
        <span className="row x-center absolute text small badge px4">
          {count}
        </span>
      )}
    </div>
  )
}
